var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 194.338,
    height: 19.976,
    viewBox: "0 0 194.338 19.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ELLEVATE_LOGO",
    "data-name": "ELLEVATE LOGO",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M332.994,194.149v4.522h-17v3.444h16.026v3.953H315.99V209.6h17.224v4.522H309.681V194.149Z",
    transform: "translate(-309.681 -194.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M479.21,194.149v4.522h-17v3.444h16.025v3.953H462.206V209.6H479.43v4.522H455.9V194.149Z",
    transform: "translate(-399.748 -194.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M525.8,194.149h7.067l8.3,15.094,8.486-15.094h7.129l-11.64,19.976h-8.108Z",
    transform: "translate(-442.806 -194.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M611.06,194.149h8.58l11.514,19.976h-7l-2.082-3.564H608.5l-2.019,3.564H599.23Zm8.77,12.249-4.542-7.966-4.479,7.966Z",
    transform: "translate(-488.04 -194.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M687.782,199.09h-9.37v-4.941h25.142v4.941h-9.369v15.035h-6.4Z",
    transform: "translate(-536.816 -194.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M777.787,194.149v4.522h-17v3.444h16.025v3.953H760.783V209.6h17.224v4.522H754.474V194.149Z",
    transform: "translate(-583.669 -194.149)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(28.546 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(3.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M423.15,223.3h6.4V209.037l-6.4,6.84Z",
    transform: "translate(-411.269 -203.32)",
    fill: "#6be0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M410.5,194.148h-6.4L392.22,206.859l-.009.009v6.373l.009-.009v.892h6.4v-7.3Z",
    transform: "translate(-392.211 -194.148)",
    fill: "#6be0a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M384.017,204.359l9.56-10.211h-6.4l-3.156,3.379Z",
    transform: "translate(-384.017 -194.148)",
    fill: "#6be0a0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.453b3541223136c2a7954209347e1420.svg";
export { ForwardRef as ReactComponent };